// dashboard/src/store/Reducers/commissionReducer.js - YENİ FAYL
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import axios from 'axios';
import { api_url } from '../../utils/utils'
// 🔥 QLOBAL SETTINGS-Ləri gətir
export const get_commission_settings = createAsyncThunk(
    'commission/get_commission_settings',
    async (_, { rejectWithValue, getState }) => {
        // const token = getState().auth.token
        try {
            const { data } = await axios.get(`${api_url}/api/admin/commission/settings`, {
            withCredentials: true
        })
            return data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// 🔥 QLOBAL SETTINGS-Ləri yenilə
export const update_commission_settings = createAsyncThunk(
    'commission/update_commission_settings',
    async ({ defaultRate, isActive, description }, { rejectWithValue, getState }) => {
                    // const token = getState().auth.token
        try {
            const { data } = await api.put(`/admin/commission/settings`, 
                { defaultRate, isActive, description },
                { withCredentials: true }
            )
            return data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// 🔥 Bütün seller-lərin komisyon məlumatlarını gətir
export const get_all_seller_commissions = createAsyncThunk(
    'commission/get_all_seller_commissions',
    async ({ page = 1, limit = 20, search = '' }, { rejectWithValue, getState }) => {
        // const token = getState().auth.token
        try {
            const { data } = await axios.get(
                `${api_url}/api/admin/commission/sellers?page=${page}&limit=${limit}&search=${search}`,
                { withCredentials: true }
            )
            return data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

// 🔥 Seller üçün fərdi komisyon təyin et
export const set_seller_commission = createAsyncThunk(
    'commission/set_seller_commission',
    async ({ sellerId, customCommissionRate, commissionExemptUntil, commissionNote }, { rejectWithValue, getState }) => {
        // const token = getState().auth.token
        try {
            const { data } = await api.put(`/admin/commission/seller/${sellerId}`,
                { customCommissionRate, commissionExemptUntil, commissionNote },
                { withCredentials: true }
            )
            return data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const commissionReducer = createSlice({
    name: 'commission',
    initialState: {
        globalSettings: null,
        sellers: [],
        totalSellers: 0,
        loader: false,
        successMessage: '',
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: (builder) => {
        builder
            // GET GLOBAL SETTINGS
            .addCase(get_commission_settings.pending, (state) => {
                state.loader = true
            })
            .addCase(get_commission_settings.fulfilled, (state, { payload }) => {
                state.loader = false
                state.globalSettings = payload.settings
            })
            .addCase(get_commission_settings.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })

            // UPDATE GLOBAL SETTINGS
            .addCase(update_commission_settings.pending, (state) => {
                state.loader = true
            })
            .addCase(update_commission_settings.fulfilled, (state, { payload }) => {
                state.loader = false
                state.globalSettings = payload.settings
                state.successMessage = payload.message
            })
            .addCase(update_commission_settings.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })

            // GET ALL SELLER COMMISSIONS
            .addCase(get_all_seller_commissions.pending, (state) => {
                state.loader = true
            })
            .addCase(get_all_seller_commissions.fulfilled, (state, { payload }) => {
                state.loader = false
                state.sellers = payload.sellers
                state.totalSellers = payload.total
                state.globalSettings = payload.globalSettings
            })
            .addCase(get_all_seller_commissions.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })

            // SET SELLER COMMISSION
            .addCase(set_seller_commission.pending, (state) => {
                state.loader = true
            })
            .addCase(set_seller_commission.fulfilled, (state, { payload }) => {
                state.loader = false
                state.successMessage = payload.message
                
                // Update seller in list
                const index = state.sellers.findIndex(s => s._id === payload.seller._id)
                if (index !== -1) {
                    state.sellers[index] = {
                        ...state.sellers[index],
                        ...payload.seller
                    }
                }
            })
            .addCase(set_seller_commission.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.message || 'Xəta baş verdi'
            })
    }
})

export const { messageClear } = commissionReducer.actions
export default commissionReducer.reducer